export const DATA_MANAGER_TOP_ACTION_DIV_ID = 'data-manager-action-button';
